export const TOGGLE_SHOW_DETAIL = 'TOGGLE_SHOW_DETAIL'
export const SET_DETAIL = 'SET_DETAIL'
export const RESET_STATE = 'RESET_STATE'
export const SET_FILTER = 'SET_FILTER'
export const SET_FILTER_FIELD = 'SET_FILTER_FIELD'
export const SET_QUERY = 'SET_QUERY'
export const TOGGLE_MODAL_FETCH = 'TOGGLE_MODAL_FETCH'
export const ADD_FILTER = 'ADD_FILTER'
export const PUSH_FILTER = 'PUSH_FILTER'
export const ADD_ALL_FILTER = 'ADD_ALL_FILTER'
export const RESET_ALL_FILTER = 'RESET_ALL_FILTER'
export const SET_MANUAL_FILTER = 'SET_MANUAL_FILTER'